import Header from "../components/Header";
import Footer from "../components/Footer";

function Titre() {
  return (
    <div className="relative text-center w-full mx-auto bg-cover overflow-hidden">
      <div className="px-6 relative flex items-center justify-center min-h-[250px]">
        <h1 className="font-comme font-bold text-[36px] md:text-[48px] lg:text-[60px] leading-tight text-center text-gris-sombre dark:text-blanc-sombre max-w-5xl w-full">
          La <span className="text-bleu-je">C</span>onfédération <span className="text-bleu-je">N</span>ationale des <span className="text-bleu-je">J</span>unior-<span className="text-bleu-je">E</span>ntreprises
        </h1>
      </div>
      <div className="flex justify-center mt-[-20px] mb-8">
        <img src="/images/logo_cnje.svg" alt="Logo de la CNJE" className="w-[140px] md:w-[160px] h-auto"/>
      </div>
    </div>
  );
}

function Paragraphe({ titre, children }) {
  return (
    <div className="flex flex-col items-center justify-center max-w-5xl mx-auto my-10 px-5">
      <h2 className="text-[26px] md:text-[32px] font-comme font-semibold text-gris-sombre dark:text-blanc-sombre mb-4 text-center px-4 sm:px-6 md:px-0">{titre}</h2>
      <div className="text-[16px] md:text-[18px] font-comme text-gris-sombre dark:text-blanc-sombre leading-relaxed text-justify max-w-4xl">{children}</div>
    </div>
  );
}

function Galerie() {
  const images = [
    { src: "/images/cnje-cnh.avif", alt: "Congrès national CNJE" },
    { src: "/images/cnje-mandat.avif", alt: "Formation CNJE" },
    { src: "/images/cnje-prix.avif", alt: "Remise des prix CNJE" },
  ];

  return (
    <div className="py-12 bg-white dark:bg-gris-sombre">
      <h2 className="text-center font-comme font-semibold text-[28px] md:text-[34px] text-gris-sombre dark:text-blanc-sombre mb-8">La <span className="text-bleu-je">CNJE</span> en images</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto px-6">
        {images.map((img, i) => (
          <div key={i} className="overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
            <img src={img.src} alt={img.alt} className="w-full h-[220px] object-cover hover:scale-110 transition-transform duration-500" loading="lazy"/>
          </div>
        ))}
      </div>
    </div>
  );
}

function Avantages() {
  const avantages = [
    "Une visibilité nationale au sein du réseau CNJE",
    "Des formations et ressources exclusives",
    "Des audits garantissant le professionnalisme des Junior-Entreprises",
    "Une participation active aux congrès et événements du mouvement",
  ];

  return (
    <div className="bg-gris-clair dark:bg-gris-sombre py-6 mt-8">
      <h2 className="text-center font-comme font-semibold text-[28px] md:text-[34px] text-gris-sombre dark:text-blanc-sombre mb-8">
        Pourquoi <span className="text-bleu-je">i2c</span> adhère à la CNJE
      </h2>

      <div className="flex flex-wrap justify-center gap-6 px-6 max-w-5xl mx-auto">
        {avantages.map((avantage, i) => (
          <div key={i} className="flex flex-col justify-center items-center bg-white dark:bg-blanc-sombre rounded-xl shadow-md p-6 w-[300px] md:w-[220px] h-[160px] transition-transform duration-200 hover:scale-105">
            <p className="text-gris-sombre font-comme text-[16px] text-center leading-relaxed">{avantage}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function CNJE() {
  return (
    <div className="dark:bg-fond-sombre">
      <Header/>
      <Titre/>

      <Paragraphe titre="Le mouvement des Junior-Entreprises">
        <p className="px-4 sm:px-6 md:px-0">
          La <strong>Confédération Nationale des Junior-Entreprises</strong> (CNJE)
          est l’organisme qui fédère et promeut l’ensemble des Junior-Entreprises
          françaises. Fondée en 1969, elle regroupe aujourd’hui plus de <strong>
          200 structures</strong> issues de grandes écoles et universités.
        </p>
        <p className="mt-3 px-4 sm:px-6 md:px-0">
          La CNJE garantit la qualité et la cohérence du mouvement à travers des
          <strong> audits annuels</strong>, des formations et un accompagnement
          personnalisé des Junior-Entreprises. Elle contribue à faire rayonner le
          modèle auprès des entreprises et institutions.
        </p>
      </Paragraphe>

      <Galerie/>

      <Paragraphe titre="Les missions de la CNJE">
        <ul className="list-disc ml-8 space-y-2 px-4 sm:px-6 md:px-0">
          <li>Assurer la qualité et la rigueur du mouvement</li>
          <li>Organiser des formations, congrès et événements nationaux</li>
          <li>Promouvoir le modèle Junior-Entreprise en France et à l’international</li>
          <li>Favoriser les échanges et la coopération entre les structures</li>
        </ul>
      </Paragraphe>

      <Avantages/>

      <div className="mb-16">
        <Paragraphe titre="Envie d’en savoir plus ?">
          <p className="text-center text-[18px] mt-4">
            Consultez le site officiel de la CNJE pour découvrir le mouvement et ses actions :
          </p>
          <div className="text-center mt-6">
            <a href="https://junior-entreprises.com" target="_blank" rel="noreferrer" className="bg-bleu-footer text-white font-comme px-6 py-3 rounded-xl hover:bg-gris-sombre transition-all duration-200">Visiter le site de la CNJE</a>
          </div>
        </Paragraphe>
      </div>

      <Footer/>
    </div>
  );
}

export default CNJE;